import { EraControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface UploadEraParams {
  file: File;
}

/**
 * Uploads a payer ERA/835 file (POST /api/master/era/upload-835). The backend
 * parses the X12 835 and stores the ERA as a pending entry.
 */
export const useUploadEra = () =>
  useMutationWithLoading(async (params: UploadEraParams) =>
    new EraControllerApi(getConfigObject()).uploadEra835(
      params.file,
      getXtenantId()
    )
  );
